import React from 'react'

import { List, Space, Button } from 'antd'
import styled from 'styled-components'

import {
  FileOutlined,
  YoutubeOutlined,
  DeleteOutlined
} from '@ant-design/icons'
import { useHistory, useParams } from 'react-router'

const HoverableListItem = styled(List.Item)`
  cursor: pointer;
  padding-left: 8px;
  font-size: 16px;
  &:hover {
    background-color: #f0f0f0;
    color: #1890ff;
  }
`

const getIcon = (item) => {
  if (item.type === 'video') return <YoutubeOutlined />
  if (item.type === 'file') return <FileOutlined />
  if (item.type === 'gdrive') return <img src="https://upload.wikimedia.org/wikipedia/commons/1/12/Google_Drive_icon_%282020%29.svg" style={{ width: '16px' }} />
}

const ModuleItem = ({ item, instructorAccess, removeModuleItem }) => {
  const { title, type, url } = item

  const { courseId } = useParams()

  const history = useHistory()

  const getActions = (item) => {
    if (instructorAccess)
      return (
        <span
          onClick={(event) => {
            event.stopPropagation()
          }}
        >
          <Button
            onClick={() => removeModuleItem(item)}
            type="text"
            icon={<DeleteOutlined />}
            danger
          />
        </span>
      )
    return null
  }

  const handleItemClick = () => {
    if (type === 'file' || type === 'gdrive') {
      let path = url
      let provider = type === 'gdrive' ? 'gdrive' : 'local'

      if (type === 'file' && path.startsWith('http')) {
        const urlObj = new URL(path)
        path = urlObj.pathname
      }
      // Navigate to preview page with provider flag
      history.push(`/app/file-preview?path=${encodeURIComponent(path)}&provider=${provider}`)
    } else {
      // For videos, navigate to lecture page
      history.push(`/app/course/${courseId}/lectures/${item.id}`)
    }
  }

  return (
    <HoverableListItem
      extra={getActions(item)}
      onClick={handleItemClick}
    >
      <Space size={20}>
        {getIcon(item)}
        {title}
      </Space>
    </HoverableListItem>
  )
}

export default ModuleItem
